import { anyToBoolean } from "helpers/boolean";
import { IApplication } from "store/entities/applications/interfaces";

export default abstract class ApplicationSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: Record<string, any>): IApplication {
    return {
      id: data.id,
      name: data.name,
      slug: data?.slug,
      description: data?.shortDescription || null,
      elements: {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        widgets: (data?.elements?.widgets || []).map((widget: any) => ({
          ...widget,
          appSlug: data.slug,
        })),
      },
      icons: data.icons,
      clientId: data?.authorization?.clientId,
      publishedAt: data?.publishedAt,
      ownerId: data?.ownerId,
      tutorialUrl: data?.tutorialUrl || null,
      directInstallUrl: data?.directInstallUrl || null,
      isService: anyToBoolean(data?.customProps?.isService),
      hasSettingsHidden: anyToBoolean(data?.customProps?.hasSettingsHidden),
      goToWebsiteUrl: data?.customProps?.goToWebsiteUrl,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static deserializeList(list: unknown[]) {
    // @ts-expect-error TS(2345): Argument of type '(data: Record<string, any>) => I... Remove this comment to see the full error message
    return list?.map(ApplicationSerializer.deserialize);
  }
}
